import React from 'react'
import Heading from '@/components/Heading'
import RichText from '@/utils/RichText'

const ContentCtaCentered = (props) => {
    return (
        <div className="bg-brightgreen rounded-md my-12 lg:p-12 md:p-10 p-6">
            <Heading size="h6" className="text-darkblue not-prose !mt-0 !mb-5">{props.title}</Heading>
            <div className="prose !text-darkblue prose-headings:!text-darkblue prose-a:!text-white hover:prose-a:!text-lightblue">
                <RichText>{props.content}</RichText>
            </div>
        </div>
    )
  };

export default ContentCtaCentered;
  